/* =Global js
 ----------------------------------------------- */
(function ($) {

    // Setup fixed header
    const header = $('.site-header');
    header.headroom({
        offset: header.height() * 1.5
    });

    // Primary navigation
    const primaryToggle = $('.primary-toggle');
    const primaryMenu = $('.primary-navigation');
    // Show primary menu
    primaryToggle.on('click', () => {
        header.toggleClass('primary-open');
        primaryMenu.slideToggle('easeOutQuad');
    });
    // Add submenu buttons
    primaryMenu.find('.menu-item-has-children').prepend('<i class="show-submenu fa fa-angle-down"></i>');
    // Show submenu on click
    primaryMenu.on('click', '.show-submenu, .menu-item-has-children > a', function () {
        if ($(this).hasClass('show-submenu') || $(this).attr('href') === '#') {
            const hasSub = $(this).parent('.menu-item ');
            hasSub.find('> .sub-menu').slideToggle('easeOutQuad');
            hasSub.toggleClass('is-open');
        }
    });
    // Don't go straight to page on first touch
    primaryMenu.one('touchstart', '.menu-item-has-children > a', (e) => {
        if ($('.primary-toggle').is(':hidden')) {
            e.preventDefault();
        }
    });

    // Show global search
    const searchForm = $('.site-search');
    searchForm.find('.search-toggle').on('click', (e) => {
        e.preventDefault();
        searchForm.toggleClass('visible');
        setTimeout(() => searchForm.find('.search-field').focus(), 500);
    });
    searchForm.find('.icon-close').on('click', (e) => {
        e.preventDefault();
        searchForm.toggleClass('visible');
    });

})(jQuery);
